export default __webpack_public_path__ + "static/media/grafema_minha-casa_07.c52fea5d.mp4";